import { initialData } from '../../types/initialData'
import { formatDate, formatMySqlDate, getPrettyDate, isTimestamp, parseDate } from '../../utils'

export type UserReport = {
  userId: string
  name: string
  email: string
  latestActivity: string
  enrolledCount: number
  notStartedCount: number
  inProgressCount: number
  completedCount: number
  progress: object
}

// Convert the data for it to be mapped ready on Tanstack Table.
const convertToUserReport = (data: initialData, teamData ): UserReport[] => {
  
  const usersData = data?.users ?? []

  const datePickerStartDate = parseDate( formatDate( data.datePicker.start ) ) 
  const datePickerEndDate = parseDate( formatDate( data.datePicker.end ) )
  const dateTeamCreatedOn = parseDate( formatMySqlDate( teamData.team_created_on ) )

  const userData = usersData.map(user => {

    const last_activity = isTimestamp(user.last_activity)
    ? getPrettyDate( user.last_activity )
    : '-'
    const notStarted = user.progress.filter(progress => progress.status === 'not_started').length ?? 0
    const inProgress = user.progress.filter(progress => progress.status === 'in_progress').length ?? 0
    const completed = user.progress.filter(progress => progress.status === 'completed').length ?? 0

    const formattedDate = last_activity !== '-' ? parseDate( getPrettyDate( user.last_activity, 'date' ) ) : dateTeamCreatedOn
    
    return {
        userId: user.id,
        name: user.name,
        email: user.email,
        latestActivity: last_activity,
        lastActivityDate: formattedDate,
        lastActivityUnix: user.last_activity,
        enrolledCount: user.course_count,
        notStartedCount: notStarted,
        inProgressCount: inProgress,
        completedCount: completed,
        avatarUrl: user.avatar_url,
        progress: user.progress
    }
  })

  const isInitialLoad =  formatDate( data.datePicker.start ) === formatMySqlDate( teamData.team_created_on )

  //return all
  if( isInitialLoad ) return userData

  /**
   * @TODO: do filtering and requesting in back-end 
   */

  const filteredUserData = userData.filter(user => {
    const lastActivityDate = user.lastActivityDate 

    return lastActivityDate >= datePickerStartDate && lastActivityDate <= datePickerEndDate
  })
  
  return filteredUserData
}

export const UserReportData = (data: initialData, teamData ) => {
  return convertToUserReport(data, teamData)
}
